module.exports = __webpack_public_path__ + "static/media/country_bn.298360b4.webp";